import React from 'react';
import { useAuth } from '../context/AuthContext';

const UserStatusBanner: React.FC = () => {
    const { user } = useAuth();

    // Don't show banner if no user (guest not logged in)
    if (!user) {
        return (
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 py-1.5 px-3 bg-primary-bg border-2 border-yellow-400 rounded-md">
                <p className="text-text-secondary text-sm m-0">
                    You are a <span className="font-bold">Guest</span>
                </p>
                <a
                    href="https://ko-fi.com/wisdombook"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-2.5 py-1 bg-yellow-400 hover:bg-yellow-300 text-black text-xs font-bold rounded transition-colors no-underline whitespace-nowrap"
                >
                    ☕ Support on Ko-fi
                </a>
            </div>
        );
    }

    const getStatusText = () => {
        // Capitalize first letter of badge tier
        const badgeTier = user.kofi_badge
            ? user.kofi_badge.charAt(0).toUpperCase() + user.kofi_badge.slice(1)
            : 'Member';

        if (user.nickname) {
            return (
                <>
                    You are a <span className="font-bold">{badgeTier}</span>, <span className="font-bold">@{user.nickname}</span>!
                </>
            );
        }
        return (
            <>
                You are a <span className="font-bold">{badgeTier}</span>
            </>
        );
    };

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 py-1.5 px-3 bg-primary-bg border-2 border-yellow-400 rounded-md">
            <p className="text-text-secondary text-sm m-0 flex-1">
                {getStatusText()}
            </p>
        </div>
    );
};

export default UserStatusBanner;
